import { purchaseItemInfoPop } from './resultPop/purchaseItemInfoPop'

export function paymentResult(res) {
  resultPop(res.result)
}

/**
 * @param {Object} data - ajax는 result
 */
export function resultPop(data) {
  purchaseItemInfoPop(data)
}
